module.exports = __webpack_public_path__ + "assets/img/Earlytrade-Social-Static-Ad-w540.51dc9586.png";